<template>
  <section class="content-section fodhed">

    <div class="container">
      <div class="row">



        <div class="col-7 col-md-4">
          <div class="row">
            <div class="col-2 col-md-1" style="padding: 0px;"> <a href="/"> <img class="fodpg"
                  :src="imgPath + 'images/left-arrow.png'" alt=""></a> </div>
            <div class="col-10 col-md-11 xspad">
              <div class="user-menu" style="/*! display: flow-root; *//*! text-align: end; */padding-top: 3px; ">


                <div>{{ moviedetail.mv_title }}</div>

                <div style="font-size: 12px;color: #fdba16;"> <span> {{ getLang(Languages, moviedetail.mv_lang) }}</span>
                  <span style="color: #fff;">|</span> <span> {{ moviedetail.mv_3d == null ? '2D' : '3D' }} </span> <span
                    style="color: #fff;">|</span> <span>{{ moviedetail.mv_cert }} </span> </div>

                <div class="disno1" style="font-size: 12px;color: #ec2553;"> <span>
                    {{ formattedDate(moviedetail.showtime) }}</span> </div>

              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4 disbk1" style="text-align: center;margin-top: 13px;">
          <div style="font-size: 17px;color: #fff;"> <span
              style="font-weight: 600;border: dashed 1px #fcab1c !important;padding: 10px;border-radius: 5px;">
              {{ formattedDate(moviedetail.showtime) }} </span> </div>
        </div>

        <div class="col-5 col-md-4 fodtim">
          <div style=""> <span style="border: dashed 1px #fcab1c !important;padding: 4px;;border-radius: 5px;"><i
                class="fa fa-clock-o" aria-hidden="true" style="/*! font-size: 12px; */font-weight: 100;"></i>
              {{ timeLeft }} <span style="font-size: 10px;color: #eaac14;">MINS </span><span
                style="font-size: 10px;color: #ff3b3b;"> LEFT</span></span></div>
        </div>



        <!-- <div style="padding-top: 100px;"> <img src="images/sce.png" alt=""></div> -->


        <!-- end col-12 -->
        <!-- end row -->
      </div>
      <!-- end container -->
    </div>
    <!-- end container -->
  </section>
</template>

<script>
export default {
  props: {
    moviedetail: null
  },
  data() {
    return {
      intervalTimer: null,
      selectedTime: 0,
      timeLeft: '00:00',
      endTime: '0',
      Languages: { "1": "Malayalam", '2': "Tamil", '3': "Hindi", '4': "English", '5': "Telugu", '6': "Kannada" },
      months: { "01": "Jan", "02": "Feb", "03": "Mar", "04": "Apr", "05": "May", "06": "Jun", "07": "Jul", "08": "Aug", "09": "Sep", "10": "Oct", "11": "Nov", "12": "Dec" },
      imgPath: process.env.BASE_URL,
    }
  },
  computed: {

    getLang: () => {
      return (langs, key) => {
        return langs[key]
      }

    },
    formattedDate: () => {
      return (dt) => {
        const months = [
          "Jan", "Feb", "Mar", "Apr", "May", "Jun",
          "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];

        const date = new Date(dt);
        const year = date.getFullYear();
        const month = months[date.getMonth()];
        const day = date.getDate();
        const hours = date.getHours();
        const minutes = date.getMinutes();
        const ampm = hours >= 12 ? "PM" : "AM";

        // Convert 24-hour time to 12-hour time
        const formattedHours = hours % 12 || 12;

        return `${day} ${month} ${year}, ${formattedHours}:${String(minutes).padStart(2, '0')} ${ampm}`;
      }
    }
  },
  methods: {
    setTime() {
      clearInterval(this.intervalTimer);
      this.timer(300);
    },
    timer(seconds) {
      const now = Date.now();
      const end = now + seconds * 1000;
      this.displayTimeLeft(seconds);

      this.selectedTime = seconds;
      this.displayEndTime(end);
      this.countdown(end);
    },
    countdown(end) {
      this.intervalTimer = setInterval(() => {
        const secondsLeft = Math.round((end - Date.now()) / 1000);
        if (secondsLeft === 0) {
          this.endTime = 0;
        }
        if (secondsLeft < 0) {
          clearInterval(this.intervalTimer);
      this.$emit("TimeOut");
          return this.$router.replace("/index");
        }
        this.displayTimeLeft(secondsLeft)
      }, 1000);
    },
    displayTimeLeft(secondsLeft) {
      const minutes = Math.floor((secondsLeft % 3600) / 60);
      const seconds = secondsLeft % 60;
      this.timeLeft = `${this.zeroPadded(minutes)}:${this.zeroPadded(seconds)}`;
    },
    displayEndTime(timestamp) {
      const end = new Date(timestamp);
      const hour = end.getHours();
      const minutes = end.getMinutes();
      this.endTime = `${this.hourConvert(hour)}:${this.zeroPadded(minutes)}`
    },
    zeroPadded(num) {
      return num < 10 ? `0${num}` : num;
    },
    hourConvert(hour) {
      return (hour % 12) || 12;
    }
  },

  mounted() {
    this.setTime();
  },
  beforeUnmount(){
    // console.log("timerofff");
    clearInterval(this.intervalTimer);
    // clearInterval(this.counters);
},

  emit:['TimeOut']

}
</script>
